import { Interweave } from "interweave";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import
{
  BASE_URL,
  GET_CONTENTS_BY_MENU_ID,
  GET_IMAGE_BY_MENU_ID,
  GET_MENUS_ALL_NESTED,
} from "../../constant/constants";

function items ( obj )
{
  const content = [];
  for ( const key in obj )
  {
    if ( Object.prototype.hasOwnProperty.call( obj, key ) )
    {
      const contentItem = { [ key ]: obj[ key ] };
      content.push( contentItem );
    }
  }
  return content;
}

const WithOutSilderEvent = ( props ) =>
{
  console.log( "props", props );
  const [ contents, setContents ] = useState( [] );
  const [ contentsImage, setContentsImage ] = useState( "" );
  const [ homeId, setHomeId ] = useState();

  console.log( "contentsEvent", contentsImage );
  console.log( "sfjdhjkfhkjfhasdhfkhasdf" );

  const { id } = useParams();
  useEffect( () =>
  {
    fetch( `${ GET_MENUS_ALL_NESTED }` )
      .then( ( response ) => response.json() )
      .then( ( data ) =>
      {
        console.log( "data212121", data );
        data.menus.find( ( e ) => ( e.name === "Event" ? setHomeId( e.id ) : null ) );
      } )
      .catch( () => { } );
  }, [] );

  useEffect( () =>
  {
    const fetchData = async () =>
    {
      try
      {
        const imageResponse = await fetch(
          `${ GET_IMAGE_BY_MENU_ID }/${ homeId || id || props.id }`
        );
        const imageData = await imageResponse.json();
        setContentsImage( imageData.content_images );
        console.log( "imagesContent", imageData );

        const contentResponse = await fetch(
          `${ GET_CONTENTS_BY_MENU_ID }/${ homeId || id || props.id }`
        );
        const contentData = await contentResponse.json();

        setContents( contentData?.menu_contents );
        console.log( "LiveEvents", contentData?.menu_contents );
      } catch ( error )
      {
        console.error( "Error fetching data:", error );
      }
    };

    fetchData();
  }, [ id, props.id, homeId ] );

  const newContents = items( contents );

  console.log( "Efdsfdsff", contents, contentsImage );
  const postLink =
    "https://www.facebook.com/photo/?fbid=122107282328509942&set=a.122107282580509942&rdid=p3beZqhUti2R66pG&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1FAvP37Ni1%2F";

  return (
    <section className="wpo-features-section-s6 section-padding">
      <div className="container">

        <div className="row">
          { contents.map( ( service, index ) =>
          {
            console.log( "service00000", service );

            return (
              <div
                className="col col-xl-4 col-lg-4 col-sm-6 col-12 p-3"
                key={ index }
              >
                <Link
                  to={ `/event details/${ homeId || id || props.id }/${ service?.name
                    }` }
                >
                  <div
                    className="wpo-features-item p-0"
                    style={ {
                      borderRadius: "20px",
                      width: "100%",
                      height: "660px",
                      padding: "40px 0",
                    } }
                  >
                    { contentsImage &&
                      service?.name &&
                      contentsImage[ service.name ] ? (
                      <div>
                        <div>
                          <img
                            style={ {
                              display: "block",
                              width: "100%",
                              marginLeft: "auto",
                              marginRight: "auto",
                              height: "400px",
                            } }
                            src={ `${ BASE_URL }/media/${ contentsImage[ service.name ]
                              }` }
                            alt=""
                          />
                        </div>
                        <div
                          style={ {
                            padding: "10px 20px",
                            minHeight: "200px",
                          } }
                        >
                          <Interweave
                            allowAttributes
                            allowElements
                            disableLineBreaks={ true }
                            content={ `${ service.value.slice(
                              0,
                              300
                            ) } ...see more` }
                          />
                        </div>
                      </div>
                    ) : (
                      <div
                        className="wpo-features-item p-0"
                        style={ { borderRadius: "20px" } }
                      >
                        {/* <iframe
                            title={service.value}
                            src={service?.post_link}
                           
                            style={{ border: "none", overflow: "hidden" }}
                            scrolling="no"
                            frameBorder="0"
                            allowFullScreen={true}
                            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                          ></iframe> */}

                        <iframe
                          src={ `https://www.facebook.com/plugins/post.php?href=${ service?.post_link }}&show_text=true&width=500` }
                          width="100%"
                          height="660"
                          style={ { border: "none", overflow: "hidden" } }
                          scrolling="no"
                          frameBorder={ 0 }
                          allowFullScreen="true"
                          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                        />
                      </div>
                    ) }
                  </div>
                </Link>
              </div>
            );
          } ) }
        </div>
      </div>
    </section>
  );
};

export default WithOutSilderEvent;
